export const AUTO_SETTLEMENT_TARGET_POOL = 'SEG_POOL';
export const AUTO_SETTLEMENT_HASH_VENDORS = ['SEGMENT', 'CASHLAB'] as const;

export const isHashVendorAllowed = (
    hostingBillingScheme: string | undefined,
    hashVendor: string | null | undefined
): boolean => {
    if (hostingBillingScheme?.toUpperCase() !== 'AUTO_SETTLEMENT') {
        return true;
    }

    return AUTO_SETTLEMENT_HASH_VENDORS.includes(
        hashVendor?.toUpperCase() as typeof AUTO_SETTLEMENT_HASH_VENDORS[number]
    );
};

export const restrictTargetPool = (
    hostingBillingScheme: string | undefined,
    targetPool: string | null | undefined
): string | null => {
    if (hostingBillingScheme?.toUpperCase() === 'AUTO_SETTLEMENT') {
        return AUTO_SETTLEMENT_TARGET_POOL;
    }

    return targetPool ?? null;
};
